var distributors = {

    init:function(){		
		distributors.form();
    },
 
	form:function(form){
	


		$('#distributors-search-form select').on('change', $.debounce(500, function(){
				var $this  = $(this);
				var $partial = $('#distributors-list');
				var $val  = $this.val();
				$partial.data('country',$val);
				load_partial($partial);
				return false;		
				
			})
		);
		$('#distributors-search-form input').on('input', $.debounce(500, function(){
				var $this  = $(this);
				var $partial = $('#distributors-list');
				var $val  = $this.val();
				$partial.data('q',$val);
				load_partial($partial);
				return false;		
				
			})
		); 

	}
};